import { css } from 'lit';
import componentStyles from '../../styles/component.styles.js';
export default css `
    ${componentStyles}
    :host {
        display: block;
        font-family: var(--sgdf-font-sans);
    }
    .participant-list {
        display: block;
    }

    .footer {
        display: flex;
        flex-direction: row-reverse;
    }
`;
//# sourceMappingURL=ParticipantPicker.styles.js.map